import React, { useCallback } from 'react';
import {
    RESIZE_HANDLE_STYLE,
    HEADER_LABEL_STYLE,
    HEADER_WRAPPER_STYLE,
} from './constants';

/** Column label + drag handle at far right of cell (used as column "name"). */
const ResizableHeader = React.memo(function ResizableHeader({
    columnName,
    resizeKey,
    displayWidth,
    onResizeStart,
}) {
    const handleMouseDown = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            onResizeStart(resizeKey, e.clientX, displayWidth);
        },
        [resizeKey, displayWidth, onResizeStart]
    );

    const stopResizeClick = useCallback((e) => {
        if (e.target.closest('[data-resize-handle]')) {
            e.preventDefault();
            e.stopPropagation();
        }
    }, []);

    const label = typeof columnName === 'string' ? columnName : 'Column';

    return (
        <>
            <div
                className="d-flex align-items-center w-100"
                style={HEADER_WRAPPER_STYLE}
                onClick={stopResizeClick}
            >
                <span className="text-truncate flex-grow-1 pe-1" style={HEADER_LABEL_STYLE}>
                    {columnName}
                </span>
            </div>
            <span
                data-resize-handle
                role="separator"
                aria-orientation="vertical"
                aria-label={`Resize ${label} column`}
                title="Drag to resize column"
                onMouseDown={handleMouseDown}
                onClick={stopResizeClick}
                style={RESIZE_HANDLE_STYLE}
            />
        </>
    );
});

export default ResizableHeader;
